import React, { useEffect } from 'react';
import {
  ThemeProvider,
  StyledEngineProvider,
  createTheme,
} from '@mui/material/styles';
import { ThemeProvider as StylesThemeProvider } from '@mui/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import ConfirmationModal from '@nile/sphinx/dist/modal/ConfirmationModal';
import lightOverrides from './themes/light';
import HomePageLayout from './layouts/HomePageLayout';
import Copyright from './pages/common/Copyright';
import KarnakSnackBar from './components/common/SnackBar';
import karnakService from './apis/KarnakService';

import useGlobal, { getApiResponseFromStore } from './store';

const theme = createTheme(lightOverrides);

const footerStyle = {
  position: 'absolute',
  bottom: 0,
  width: '100%',
  height: '50px',
  background: '#212121',
};

function Karnak() {
  const [globalState, globalActions] = useGlobal();

  const bootstrap = getApiResponseFromStore(
    globalState,
    karnakService.GetBootstrap,
    null,
    { serviceUri: '' }
  );
  const bootstrapConfig =
    typeof bootstrap === 'object' && bootstrap
      ? bootstrap
      : { serviceUri: '' };

  useEffect(() => {
    globalActions.executeApi(karnakService.GetBootstrap);
  }, []);

  const handleCloseSnackBar = () => {
    globalActions.hideSnackBar();
  };

  const handleCloseConfirmationModal = (confirmed) => {
    globalActions.hideConfirmationModal(confirmed);
  };

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <StylesThemeProvider theme={theme}>
          <CssBaseline />
          <HomePageLayout config={bootstrapConfig} />
          <KarnakSnackBar
            open={globalState.snackBarOpen}
            onClose={handleCloseSnackBar}
            message={globalState.snackBar.message}
            variant={globalState.snackBar.variant}
          />
          <ConfirmationModal
            open={globalState.confirmationModal.open}
            onClose={handleCloseConfirmationModal}
            message={globalState.confirmationModal.message}
          />

          <Box style={footerStyle} flexDirection="column">
            <Copyright />
          </Box>
        </StylesThemeProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default Karnak;
